import { Pipe, PipeTransform } from '@angular/core';
import { ItemProfile, ItemResource, ResourceMeta } from '@ngx-hal/models';

@Pipe({
  name: 'itemResourceMeta',
  standalone: false
})
export class ItemResourceMetaPipe implements PipeTransform {
  private itemResourceMeta?: ResourceMeta<never>;

  /**
   * Transforms an `ItemProfile` into a `ResourceMeta` object for the given entity type.
   *
   * This method constructs and caches a `ResourceMeta` object based on the `href` property
   * of the provided `itemProfile`. It removes any fragment identifier from the `href` and
   * generates related links for the resource, its profile, and its items.
   *
   * @typeParam Entity - The type of the item resource.
   * @param itemProfile - The profile object containing metadata and links for the entity.
   * @returns The constructed `ResourceMeta` object for the specified entity.
   */
  transform<Entity extends ItemResource>(itemProfile: ItemProfile<Entity>): ResourceMeta<Entity> {
    if (!this.itemResourceMeta) {
      const href = itemProfile?.alps?.href?.replace(/#[^/]*$/, '');
      this.itemResourceMeta = {
        link: { href },
        profile: { href },
        items: { href: href?.replace(/\/profile\//, '/') },
      };
    }

    return this.itemResourceMeta as ResourceMeta<Entity>;
  }
}
